import axios from "axios";

export interface CreateFoodPoisoning {
  companyId: string;
  companyLocationId: string;
  registratedUser: string;
  poisoningDate: string;
  poisoningDish: string;
  numberConsumed: string;
  sickAmount: string;
  consumptionDate: string;
  symptomsDate: string;
  visitedDoctor?: string;
  contactedAuthority?: string;
  note?: string;
  leftOvers: string;
  symptoms?: string;
  file?: string;
}

export interface FoodPoisoning {
  id: string;
  companyId: string;
  companyLocationId: string;
  registratedUser: string;
  poisoningDate: string;
  poisoningDish: string;
  numberConsumed: string;
  sickAmount: string;
  consumptionDate: string;
  symptomsDate: string;
  visitedDoctor?: string;
  contactedAuthority?: string;
  note?: string;
  file: string;
  leftOvers: string;
  symptoms?: string;
  creationDate: string;
}

export function addFoodPoisoning(foodPosioning: CreateFoodPoisoning) {
  return axios
    .post(`/FoodPoisonings/addfoodpoisoning`, foodPosioning)
    .then((res) => res.data);
}

export function getAllFoodPoisoningsByLocationId(companyLocationId: string) {
  return axios
    .get<FoodPoisoning[]>(`/FoodPoisonings/getallfoodpoisoningsbylocationid`, {
      params: { companyLocationId },
    })
    .then((res) => res.data);
}

export function updateFoodPoisoning(
  foodPoisoning: Omit<FoodPoisoning, "creationDate">,
) {
  return axios
    .put(`/FoodPoisonings/updatefoodpoisoning`, foodPoisoning)
    .then((res) => res.data);
}

export function getPoisiningById(id: string) {
  return axios
    .get<FoodPoisoning>("/FoodPoisonings/getfoodpoisoningbyid", {
      params: { id: id },
    })
    .then((res) => res.data);
}
